// store/modules/base.js
const baseModule = {
    namespaced: true, // 名前空間を有効にする
    state: () => ({
      base: '' // 初期値
    }),
    mutations: {
      setBase(state, base) {
        // console.log('base.js setBase() mutation called with:', base); // 追加のログ
        state.base = base;
      }
    },
    actions: {
      initializeBase({ commit }, base) {
        // console.log('base.js initializeBase() action called with:', base); // 追加のログ
        commit('setBase', base);
      }
    },
    getters: {
      base: (state) => {
        // console.log('base.js Getter for base called, value:', state.base); // デバッグログ
        return state.base;
      }
    }
  };
  
  export default baseModule;